import { useState } from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, MessageBar, MessageBarType, ChoiceGroup, IChoiceGroupOption } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { ChatExchange } from '../../components/ChatExchange';
import { userAPI } from '../../UserAPI';
import { useAtom } from 'jotai';
import { authenticationAtom } from '../../State';

interface UseTestDialogProps {
    onOrder?: (marketplaceOffer: any) => void;
}

export function useTestDialog({ onOrder }: UseTestDialogProps = {}) {
    const { t } = useTranslation();
    const [authentication] = useAtom(authenticationAtom) as any;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedMarketplaceOffer, setSelectedMarketplaceOffer] = useState<any>(null);
    const [conversation, setConversation] = useState<any>({ messages: [] });
    const [testMode, setTestMode] = useState<string>('toolOnly');

    const testModeOptions: IChoiceGroupOption[] = [
        {
            key: 'toolOnly',
            text: 'Nur dieses Werkzeug benutzen',
        },
        {
            key: 'withExisting',
            text: 'Dieses Werkzeug mit bereits eingesetzten Werkzeugen testen',
        },
    ];

    const openTestDialog = async (marketplaceOffer: any) => {
        console.log('Marketplace offer >>>', marketplaceOffer);
        setSelectedMarketplaceOffer(marketplaceOffer);
        const newConversation = await userAPI.createConversation(authentication.customer);
        setConversation(newConversation);
        setIsOpen(true);
    };

    // Get example prompts from the marketplace offer
    const getExamplePrompts = (marketplaceOffer: any) => {
        if (!marketplaceOffer) return [];
        
        // Use the sampleRequests property from the marketplace offer
        return marketplaceOffer.sampleRequests || [];
    };

    const closeTestDialog = () => {
        setIsOpen(false);
    };

    const TestDialog = () => (
        <Dialog
            hidden={!isOpen}
            onDismiss={closeTestDialog}
            maxWidth={1000}
            minWidth={1000}
            dialogContentProps={{
                type: DialogType.normal,
                title: t('settingsPanel.agentPanel.testDialog.title'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <div className='marginBottomM'>
                <ChoiceGroup
                    selectedKey={testMode}
                    options={testModeOptions}
                    onChange={(_, option) => option && setTestMode(option.key)}
                    styles={{
                        flexContainer: {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '20px'
                        }
                    }}
                />
            </div>
            <div className='marginTopM displayFlex flexDirectionColumn' style={{ height: '500px' }}>
                <ChatExchange
                    conversation={conversation}
                    showSuggestions={false}
                    showLogo={false}
                    fullWidth={true}
                    height="100%"
                    sampleRequests={getExamplePrompts(selectedMarketplaceOffer)}
                    toolFilter={testMode === 'toolOnly' ? [`marketplace_${selectedMarketplaceOffer?._id}`] : []}
                />
            </div>
            <DialogFooter className="marginTopL">
                {onOrder &&
                    <PrimaryButton onClick={() => {
                        closeTestDialog();
                        onOrder(selectedMarketplaceOffer);
                    }} text={t('settingsPanel.agentPanel.order')} />
                }
                <DefaultButton onClick={closeTestDialog} text={t('global.close')} />
            </DialogFooter>
        </Dialog>
    );

    return {
        TestDialog,
        openTestDialog,
        closeTestDialog
    };
} 